import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { BylineConnectionsTrigger, BylineConnectionsWrapper } from './BylineConnectionsTrigger.tsx';
import { MAX_BYLINE_CONNECTION_ICONS } from './utils/getBylineConnectionIcons.ts';
import { createPlaceholderConnectionIcon } from './utils/placeholderConnectionIcon.tsx';

const i18n = defineMessages({
	loadingConnections: {
		id: 'byline-connections.loading',
		defaultMessage: 'Loading connections',
		description: 'Accessible label for the connections byline loading spinner',
	},
});

type BylineConnectionsPlaceholderVisualProps = {
	testId?: string;
};

const placeholderIcons = Array.from({ length: MAX_BYLINE_CONNECTION_ICONS }, (_, index) =>
	createPlaceholderConnectionIcon(index),
);

/**
 * The disabled Teamwork Graph logo + label + app-icon stack placeholder shown while the byline
 * connections item is resolving. Shared by the SSR/loadable placeholder and the
 * loaded component's own loading state so the footprint lines up across the
 * SSR → client-load → data-load → item handoff, avoiding layout shift. All loading
 * states reserve three tiles; the loaded stack fills spare slots with AI tool icons.
 */
export const BylineConnectionsPlaceholderVisual = ({
	testId = 'byline-connections-ssr-placeholder',
}: BylineConnectionsPlaceholderVisualProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<BylineConnectionsWrapper
			appearance="placeholder"
			role="status"
			aria-label={formatMessage(i18n.loadingConnections)}
			data-testid={testId}
		>
			<BylineConnectionsTrigger
				appearance="placeholder"
				links={[]}
				additionalIcons={placeholderIcons}
			/>
		</BylineConnectionsWrapper>
	);
};
